import { registerQuery } from 'data-fetching-client';
import { fetchTroubleshootTimesPage, fetchV2TroubleshootTimes } from 'MeetingsLib/api/troubleshootAPI';
export const fetchV2TroubleshootTimesQuery = registerQuery({
  fieldName: 'troubleshootTimes',
  args: ['slug', 'now'],
  fetcher: fetchV2TroubleshootTimes
});
export const fetchTroublshootTimesPageQuery = registerQuery({
  fieldName: 'troubleshootTimesPage',
  args: ['slug', 'monthOffset'],
  fetcher: fetchTroubleshootTimesPage
});